import { HashRouter, Routes, Route, Navigate } from 'react-router-dom'
import { NotificationProvider } from '@alwindows/shared'
import { ScrollToTop } from '@alwindows/shared/a11y'
import { Layout } from './components/Layout'
import { RouteAnalytics } from './components/RouteAnalytics'
import { IntroVisibilityProvider } from './components/IntroVisibility'
import { BreadcrumbProvider } from './components/Breadcrumb'
import { QuoteProvider } from './quote/QuoteContext'
import {
  ROUTE_EDIT,
  ROUTE_PAYMENT,
  ROUTE_SELECT_SCREENS,
  ROUTE_SUBMIT,
  ROUTE_SUMMARY,
} from './routes'
import { ScreenHome } from './pages/ScreenHome'
import { PricingCalc } from './pages/PricingCalc'
import { Edit } from './pages/Edit'
import { Summary } from './pages/Summary'
import { Submit } from './pages/Submit'
import { Payment } from './pages/Payment'

export function App() {
  return (
    <HashRouter>
      {/* Scroll to the top of the app container on route change rather than
          to (0, 0). The plugin is mounted inside the live WP theme; jumping
          past the theme header on every navigation is disorienting. */}
      <ScrollToTop selector=".al-sc" />
      <RouteAnalytics />
      <NotificationProvider>
        <IntroVisibilityProvider>
          <BreadcrumbProvider>
            <QuoteProvider>
              <Layout>
                <Routes>
                  {/* Canonical paths are the LEGACY app's routes verbatim
                      (see src/routes.ts) — SAP's quote-approval email links
                      to #/screen/payment and customers hold years of old
                      bookmarks, so the URLs must not change. */}
                  <Route path="/" element={<ScreenHome />} />
                  <Route path={ROUTE_SELECT_SCREENS} element={<PricingCalc />} />
                  <Route path={`${ROUTE_EDIT}/:sono/:itemNo`} element={<Edit />} />
                  <Route path={ROUTE_SUMMARY} element={<Summary />} />
                  <Route path={ROUTE_SUBMIT} element={<Submit />} />
                  <Route path={ROUTE_PAYMENT} element={<Payment />} />
                  {/* Legacy intro/address pages both live inside ScreenHome
                      now ("/screen" was the intro, "/screen/calculator" the
                      address step). */}
                  <Route path="/screen" element={<Navigate to="/" replace />} />
                  <Route path="/screen/calculator" element={<Navigate to="/" replace />} />
                  {/* Unknown hashes (including this rebuild's interim short
                      paths) fall back to the start instead of a blank page. */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            </QuoteProvider>
          </BreadcrumbProvider>
        </IntroVisibilityProvider>
      </NotificationProvider>
    </HashRouter>
  )
}
